import React from "react";
import POSDashboard from "../components/pos/pages/Dashboard";
import { CartProvider } from "../components/pos/contexts/cartContext";
import ProtectedRoute from "./ProtectedRoute";
import MainLayout from "../components/CommonComponents/MainLayout";
import TransactionList from "../components/transaction/TransactionList";
import POSProductsTable from "../components/pos/pages/POSProductsTable";
import { POSProductsProvider } from "../components/pos/contexts/POSProductContext";
import ExpensesPage from "../components/pos/pages/ExpensesPage";

// POS Routes
export const posRoutes = [
    {
        path: "/dashboard",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <MainLayout>
                    <CartProvider>
                        <POSDashboard />
                    </CartProvider>
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/transactions",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <MainLayout>
                    <TransactionList restrictToToday={true} showSummary={true} useExpensesPagination={true} />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/expenses",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <MainLayout>
                    <ExpensesPage />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/products",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <MainLayout>
                    <POSProductsProvider>
                        <CartProvider>
                            <div className="flex flex-col h-full">
                                <div className="flex-1 min-h-0 overflow-auto p-4">
                                    <POSProductsTable />
                                </div>
                            </div>
                        </CartProvider>
                    </POSProductsProvider>
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/pre-release",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <MainLayout>
                    <React.Suspense fallback={<div>Loading...</div>}>
                        {React.createElement(require("../components/pos/pages/PreReleasePage.js").default)}
                    </React.Suspense>
                </MainLayout>
            </ProtectedRoute>
        ),
    },
];
